// extracted by mini-css-extract-plugin
module.exports = {"root":"option-group_root__3HfAS","options":"option-group_options__3Q3OT"};